import React, { useCallback, useState, useEffect } from 'react';
import {
    get as _get
} from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { TimelineService } from 'e1p-capability-journey';
import metadata from '../RiskAnalysisPage.metadata.json5';
import messages from '../RiskAnalysisPage.messages';

function RiskAnalysisPage(props) {
    const { authHeader, authUserData } = useAuthentication();
    const {
        wizardData: submissionVM,
        isSkipping
    } = props;
    const fullQuoteType = submissionVM.value.quoteType === 'Full';
    const [manualLossList, setManualLossList] = useState([]);
    const translator = useTranslator();

    const canViewPremiumAdjustment = authUserData.permissions_Ext.includes('viewpremiumadjustment_ext');
    // Display the tab only for user with Viewpremiumstabilizationdetail permissions and premium stabilization information is not empty
    const isPremiumStabilizationTabVisible = authUserData.permissions_Ext.includes('viewpremiumstabilizationdetail_ext')
        && authUserData.permissions_Ext.includes('viewpremiumstabilizationtab_ext')
        && _get(submissionVM, 'lobData.personalUmbrella_EU.premiumStability.value') !== undefined;

    const resolvers = {
        resolveCallbackMap: {
            onValidate: () => {},
        },
    };

    useEffect(()=>{
        if(fullQuoteType){
            const historyPromise = TimelineService.getTimeline(
                {
                    policyNumber: _get(submissionVM, 'value.policyNumber'),
                    relatedItem: 'Policy'
                },
                authHeader
            );
            
            historyPromise.then((response) => {
                const lossHistoryEvent = response.events.find((event) => event.description?.includes('Self-Declared'))?.description;
                
                if (lossHistoryEvent) {
                    setManualLossList(lossHistoryEvent.split("\n"));
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            labelPosition: 'top'
        },
        riskAnalysisPropertyPageLoadingIndicator: {
            loaded: true,
            text: translator(messages.doingRateMessage)
        },
        riskAnalysisTabs: {
            defaultActiveTab: 'lossesAndViolationTab'
        },
        lossesAndViolationComponent: {
            submissionVM,
            isSkipping,
            showErrors: false,
            authUserData,
            isVerified: fullQuoteType,
            updateWizardData: () => {},
            disregardFieldValidation: () => {},
            viewOnlyMode: true
        },
        UWIssuesComponentId: {
            submissionVM,
            updateWizardData: () => {},
            authHeader,
            viewOnlyMode: true
        },
        premiumTab: {
            visible: (isPremiumStabilizationTabVisible)
                || (canViewPremiumAdjustment
                    && _get(submissionVM, 'isPremiumAdjustmentTransactionAllowed_Ext.value'))
        },
        riskAnalysisPremiumComponent: {
            transactionVM: submissionVM,
            updateWizardData: () => {},
            onValidate: () => {},
            showErrors: false,
            viewOnlyMode: true
        },
        manualLossesHistory:{
            manualLossList,
            visible: fullQuoteType && manualLossList.length > 0
        }
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(
                metadata.pageContent,
                submissionVM,
                id,
                path,
                overrideProps
            ),
        [overrideProps, submissionVM]
    );

    const onNext = useCallback(() => submissionVM, [submissionVM]);

    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                resolveValue={readValue}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

RiskAnalysisPage.propTypes = wizardProps;
export default RiskAnalysisPage;
